import { CheckCheck } from "lucide-react";
import { ICON_BASE_PATH } from "@/app/utils/config";

interface NotificationTabItem {
  key: string;
  label: string;
  count: number;
}

interface NotificationTabProps {
  notificationTabs: NotificationTabItem[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  unreadOnly: boolean;
  onUnreadOnlyChange: (value: boolean) => void;
  onMarkRead: () => void;
  onArchive: () => void;
  onDelete: () => void;
  onSelectAll: () => void;
  allSelected: boolean;
}

export const NotificationTab = ({
  notificationTabs,
  activeTab,
  onTabChange,
  unreadOnly,
  onUnreadOnlyChange,
  onMarkRead,
  onArchive,
  onDelete,
  onSelectAll,
  allSelected,
}: NotificationTabProps) => {
  return (
    <>
      <div className="notification-tabs">
        {notificationTabs.map((tab) => {
          const isActive = activeTab === tab.key;

          return (
            <button
              key={tab.key}
              type="button"
              className={`notification-tab ${isActive ? "is-active" : ""}`}
              onClick={() => onTabChange(tab.key)}
            >
              <img
                src={`${ICON_BASE_PATH}${
                  isActive ? "mobileicon.svg" : "mobilegrey.svg"
                }`}
                alt={tab.label}
              />

              <span>{tab.label}</span>

              <span className="notification-tab__count">
                {tab.count.toString().padStart(2, "0")}
              </span>
            </button>
          );
        })}
      </div>

      <div className="notification-toolbar">
        <div className="notification-toolbar__group">
          <span className="notification-toolbar__label">Mark as :</span>

          <button
            type="button"
            className="notification-action-btn notification-action-btn--read"
            onClick={onMarkRead}
          >
            <img src={`${ICON_BASE_PATH}phonewrite.svg`} alt="" />
            Read
          </button>

          <button
            type="button"
            className="notification-action-btn notification-action-btn--archive"
            onClick={onArchive}
          >
            <img src={`${ICON_BASE_PATH}phonewrite.svg`} alt="" />
            Archive
          </button>

          <button
            type="button"
            className="notification-action-btn notification-action-btn--delete"
            onClick={onDelete}
          >
            <img src={`${ICON_BASE_PATH}phonewrite.svg`} alt="" />
            Delete
          </button>
        </div>

        <div className="notification-toolbar__group">
          <label className="notification-toggle">
            Unread Only
            <button
              type="button"
              role="switch"
              aria-checked={unreadOnly}
              className={`notification-toggle__switch ${
                unreadOnly ? "is-on" : ""
              }`}
              onClick={() => onUnreadOnlyChange(!unreadOnly)}
            />
          </label>

          <button
            type="button"
            className="notification-select-all"
            onClick={onSelectAll}
          >
            {allSelected ? "Clear All" : "Select All"}

            <CheckCheck size={14} />
          </button>
        </div>
      </div>
    </>
  );
};
